export default __webpack_public_path__ + "static/media/PurplePower.46d9dad6117893857628c2de5172b6c0.webp";